import { Box, Flex } from '@chakra-ui/react';

import { AlarmClockIcon } from 'Asset/icon';
import { TextMedium, TextRegular } from 'UiKit/typography';

import styles from './styles.module.css';

const ClockDatetime = ({ label, time, date }) => {
  const isEmpty = time === '-' && date === '-';
  return (
    <Flex className={styles['clock-datetime__container']}>
      <TextRegular fontSize="var(--font-caption1)">{label}</TextRegular>
      <Box display="flex" alignItems="center" gap="6px">
        <AlarmClockIcon size={14} color="var(--color-neutral50)" />
        <TextMedium className={styles['clock-datetime__time']}>{time}</TextMedium>
        <TextRegular className={`${styles['clock-datetime__date']} ${isEmpty && styles['clock-datetime__date--empty']}`}>{date}</TextRegular>
      </Box>
    </Flex>
  );
};

export default ClockDatetime;
